import { FolderResponse, FolderScenarioResponse } from "@Shared/schemas/projects/projectSchemas";
import { createContext, useContext } from "react";

interface IFolderExplorerContext {
  selectedFolderId?: number;
  onSelectFolder: (folder: FolderResponse) => void;
  onUpdateFolderName: (folderId: number, name: string) => void;
  onScenarioClick: (scenario: FolderScenarioResponse) => void;
}

const FolderExplorerContext = createContext<IFolderExplorerContext | undefined>(undefined);

export function useFolderExplorerContext() {
  const context = useContext(FolderExplorerContext);
  if (!context) {
    throw new Error("useFolderExplorerContext must be used within a FolderExplorerProvider");
  }
  return context;
}

export const FolderExplorerProvider = FolderExplorerContext.Provider;

